module.exports = __webpack_public_path__ + "img/bakingIgredient9.6816f0ae.jpeg";